export default __webpack_public_path__ + "static/media/login-img.2961da1d.png";